import { RootState } from './index'

// Auth
export const selectAuthState = (state: RootState) => state.auth

// QrAuth
export const selectQrAuthState = (state: RootState) => state.qrAuth

// Consult
export const selectConsultState = (state: RootState) => state.consult

// Modal
export const selectModalState = (state: RootState) => state.modal

// Error
export const selectErrorState = (state: RootState) => state.error

// Upload Progress
export const selectUploadProgressState = (state: RootState) =>
    state.uploadProgress
